// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"j9-z"};